import { useEffect } from 'react';
import { Box, Stack } from '@mui/material';

import paymentStore from '@/store/modules/paymentStore';
import { useMySubscription } from '@/hooks/queries/subscription/useMySubscription';

import { PageHeader } from './_shared';
import CurrentSubscriptionSection from './subscription/CurrentSubscriptionSection';
import PlanGridSection from './subscription/PlanGridSection';
import PaymentMethodsSection from './subscription/PaymentMethodsSection';
import PaymentHistorySection from './subscription/PaymentHistorySection';

/**
 * 구독 결제 페이지.
 *
 * 섹션:
 *   ① 현재 구독 상태 + 사용량 + 해지/재개
 *   ② 플랜 그리드 (선택/변경)
 *   ③ 결제 수단 관리 (NicePay 빌링키)
 *   ④ 결제 내역 + 변경 이력
 */
const SubscriptionPage = () => {
    const { data: subscription } = useMySubscription();

    // 다른 페이지에서 결제 진행 흔적이 남아 있을 수 있으니 마운트 시 초기화
    useEffect(() => {
        paymentStore.getState().resetPayment();
    }, []);

    return (
        <Box>
            <PageHeader title="구독" desc="자동DM Pro 플랜을 구독하고 관리하세요" />
            <Stack spacing={2.5}>
                <CurrentSubscriptionSection />
                <PlanGridSection subscription={subscription ?? null} />
                <PaymentMethodsSection />
                <PaymentHistorySection />
            </Stack>
        </Box>
    );
};

export default SubscriptionPage;
